/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".scroll-guide[_ngcontent-%COMP%]{-webkit-animation:.9s infinite alternate slidein;animation:.9s infinite alternate slidein;position:relative;margin-bottom:35px}.scroll-guide[_ngcontent-%COMP%]::after{content:'';display:block;width:0;height:0;position:absolute;left:50%;bottom:-25px;border-left:10px solid transparent;border-right:10px solid transparent;border-top:15px solid #6bbe49;-webkit-transform:translateX(-50%);transform:translateX(-50%)}@-webkit-keyframes slidein{from{bottom:0}to{bottom:-20px}}@keyframes slidein{from{bottom:0}to{bottom:-20px}}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/scroll-guide/scroll-guide.component.scss.shim.ngstyle.js.pre-build-optimizer.js